import { isAdmin } from 'permissions/v1/roles';
import { canList, canView, noPermissions } from 'permissions/v1/index';
import { hasEmailTracking } from 'permissions/v1/preferences';

const permission = 'EmailLog';

const list = (profile) => isAdmin(profile) || canList(permission, profile);
const view = (profile) => isAdmin(profile) || canView(permission, profile);

const permissions = (profile) => {
  if (!hasEmailTracking(profile)) return noPermissions;

  return {
    list: list(profile),
    view: view(profile),
    create: false, // Read-only
    update: false, // Read-only
    destroy: false, // Read-only
  };
};

export default permissions;
